<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="true"
  [style]="{ width: '60rem', maxWidth: '95vw' }"
  header="Detalhes do Pagamento"
>
  @if (installment(); as installment) {
    @if (
      installment.amount != null ||
      installment.taxAmount != null ||
      lateFeeTotal() > 0
    ) {
      <div class="mb-4">
        @if (installment.amount != null) {
          <p class="mb-2">
            <b> Valor da parcela: </b>
            {{ installment.amount | currency }}
          </p>
        }
        @if (installment.taxAmount != null) {
          <p class="mb-2">
            <b> Impostos: </b>
            {{ installment.taxAmount | currency }}
          </p>
        }
        @if (lateFeeTotal() > 0) {
          <p class="mb-2">
            <b> Multa por atraso: </b>
            {{ lateFeeTotal() | currency }}
          </p>
        }
      </div>
      <hr class="mb-4" />
    }
  }
  @if (payments().length > 0) {
    <p-table [value]="pagedPayments()" [showGridlines]="true">
      <ng-template #header>
        <tr>
          <th class="bg-gray-200!">Data</th>
          <th class="bg-gray-200!">Método de Pagamento</th>
          <th class="bg-gray-200!">Dados do Pagamento</th>
          <th class="bg-gray-200!">Valor</th>
          <th class="bg-gray-200!">ID pagamento</th>
          <th class="bg-gray-200!">Status</th>
        </tr>
      </ng-template>
      <ng-template #body let-payment>
        <tr>
          <td>{{ payment.date | date: "dd/MM/yyyy HH:mm" }}</td>
          <td>{{ payment.method }}</td>
          <td>
            @if (payment.card) {
              {{ payment.card.brand | titlecase }} ••••
              {{ payment.card.displayNumber }}
            } @else {
              -
            }
          </td>
          <td>{{ payment.amount | currency }}</td>
          <td>{{ payment.providerPaymentId }}</td>
          <td>
            <div class="w-fit">
              <app-tag-status
                [status]="payment.statusTag"
                [text]="payment.status"
              ></app-tag-status>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
    @if (payments().length > 5) {
      <p-paginator
        [first]="first()"
        [rows]="rows()"
        [totalRecords]="payments().length"
        [rowsPerPageOptions]="[5, 10, 20, 50]"
        (onPageChange)="onPageChange($event)"
      />
    }
  } @else {
    <p>Nenhum detalhe de pagamento disponível.</p>
  }
</p-dialog>
